import { MainLayout } from "layouts";
import { TextInput } from "components/TextInput";
import { TextArea } from "components/TextArea";
import { UploadImage } from "components/UploadImage";
import { Button } from "components/Button";
import { ThreeDotMenu } from "components/ThreeDotMenu";
import { RichRext } from "components/RichText";
import { Badge } from "components/Badge";

import { useArticlePage } from "./hooks";
import { menuItems } from "./helpers";

export const ArticlePage = ({
  match: {
    params: { id },
  },
}: any) => {
  const {
    formData,
    inputChanged,
    onFileChange,
    onFormSave,
    onDeleteArticle,
    onRichTextChange,
    onPublishClick,
  } = useArticlePage(id);

  const resolveTitle = () => {
    if (id < 0) return "Create article";
    return "Edit article";
  };

  return (
    <MainLayout
      title={resolveTitle()}
      badge={
        <Badge
          text={formData.published ? "Published" : "Unpublished"}
          color={formData.published ? "green" : "red"}
        />
      }
      rightElement={
        id > 0 ? (
          <ThreeDotMenu
            menuItems={menuItems(
              formData.published,
              onDeleteArticle,
              onPublishClick
            )}
          />
        ) : undefined
      }
    >
      <form className="flex flex-col gap-3">
        <TextInput
          name="title"
          type="text"
          value={formData.title}
          onChage={inputChanged}
          label="Title"
        />
        <div className="form-row">
          <TextInput
            containerClassName="flex-1"
            name="slug"
            type="text"
            value={formData.slug}
            onChage={inputChanged}
            label="Slug"
          />
        </div>
        <div className="form-row">
          <TextInput
            containerClassName="flex-1"
            name="metaTitle"
            type="text"
            value={formData.metaTitle}
            onChage={inputChanged}
            label="Meta title"
          />
        </div>
        <TextArea
          name="metaDescription"
          value={formData.metaDescription}
          onChage={inputChanged}
          rows={2}
          label="Meta description"
        />
        <RichRext
          label="Content"
          value={formData.content}
          onBlur={(newContent) => onRichTextChange(newContent, "content")}
        />
        <UploadImage
          label="Article image"
          imageUrl={formData.image?.url}
          onChange={onFileChange}
        />
        <Button label="Save" className="md:w-36" onClick={onFormSave} />
      </form>
    </MainLayout>
  );
};
